import { render, staticRenderFns } from "./IcoDot4Grid.vue?vue&type=template&id=40962ac0"
import script from "./IcoDot4Grid.vue?vue&type=script&lang=js"
export * from "./IcoDot4Grid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports